import { Button } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  getTermsOfService,
  getTOSStatus,
  postTermsOfService,
} from "../../services/api-services/termsService";
import store from "../../store";
import { showAlert } from "../../store/actions/feedback";
import Loader from "../common/Loader";
import DownwardArrow from "../../assets/icons-svg/downward-arrow.svg";
import { ONBOARDING_STEPS, ROUTES, VIEWS } from "../constants/user-info.const";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../routing/Routing";
import { onboardingActions } from "../../store/actions/steps";
import CheckIcon from "../../assets/icons-svg/check.svg";
import { Formik } from "formik";
import debounce from "../../utils/debounce";
import hideScroll from "../../utils/hideScroll";
import { connect } from "react-redux";
interface TermsOfService {
  data: string;
}
function TermsOfService(props: any) {
  const { isNavigateToNext } = props;
  const [tos, setTos] = useState("");
  const [isloading, setIsLoading] = useState(true);
  const { viewName, setViewName } = useContext(AppContext);
  const navigate = useNavigate();
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const [showScroller, setShowScroller] = useState(true);
  const nextButtonRef: any = document.getElementById("emp-next");
  const mountedRef = useRef(true);
  const [isShowFooterLoader, setIsShowFooterLoader] = useState(false);

  const showErrorMessage = (error) => {
    const errorMessage = error.status?.message;
    store.dispatch(
      showAlert({
        alertType: "error",
        alertText: errorMessage,
      })
    );
  };

  useEffect(() => {
    return () => {
      mountedRef && (mountedRef.current = false);
      nextButtonRef && (nextButtonRef.disabled = false);
    };
  }, []);

  const navigateToESign = () => {
    if (isNavigateToNext === false) return;
    setViewName(VIEWS.eSign);
    navigate(ROUTES.eSign);
  };
  const updateCompletedStep = () => {
    store.dispatch({
      type: onboardingActions.UPDATE_ONBOARDING_STEPS,
      state: ONBOARDING_STEPS.termsOfService,
    });
  };
  const checkIfTOSAccepted = (res) => {
    return res.data && res.data.latest_terms_accepted;
  };
  const getTOSStatusOnLoad = () => {
    getTOSStatus()
      .then((res: any) => {
        setIsLoading(false);
        if (!mountedRef.current) return null;
        if (checkIfTOSAccepted(res)) onAcceptTerms();
      })
      .catch((error) => {
        if (!mountedRef.current) return null;
        setIsLoading(false);
        showErrorMessage(error);
      });
  };
  useEffect(() => {
    getTermsOfService()
      .then((res: any) => {
        if (!mountedRef.current) return null;
        getTOSStatusOnLoad();
        setTos(res.data);
      })
      .catch((error) => {
        if (!mountedRef.current) return null;
        setIsLoading(false);
        showErrorMessage(error);
      });
  }, []);
  const onSubmit = () => {
    const postParam = {
      latest_terms_accepted: true,
    };
    setIsShowFooterLoader(true);
    postTermsOfService(postParam)
      .then(() => {
        setIsShowFooterLoader(false);
        navigateToESign();
        updateCompletedStep();
      })
      .catch((error) => {
        setIsShowFooterLoader(false);
        showErrorMessage(error);
      });
  };

  const hideScrollButton = debounce(
    () =>
      hideScroll(
        () => setShowScroller(false),
        () => setShowScroller(true)
      ),
    50
  );

  useEffect(() => {
    window.addEventListener("scroll", hideScrollButton);
    return () => {
      window.removeEventListener("scroll", hideScrollButton);
    };
  }, []);

  const onAcceptTerms = () => {
    setHasAcceptedTerms(true);
    if (nextButtonRef) {
      nextButtonRef.disabled = false;
    }
  };
  return (
    <div className="federal-taxes user-details__content">
      <Formik onSubmit={onSubmit} innerRef={props.formRef} initialValues={{}}>
        {isloading ? (
          <Loader />
        ) : (
          <div className="user-details--section">
            <p>
              Using 1800Accountant’s payroll features requires that you read and
              accept Gusto’s terms of service.
            </p>
            <h3>Gusto’s Terms of Service</h3>
            <p dangerouslySetInnerHTML={{ __html: tos }}></p>

            <div className="terms-of-service__buttons">
              {hasAcceptedTerms ? (
                <div>
                  <p className="terms-of-service__accepted">
                    Terms and Conditions Accepted
                  </p>
                </div>
              ) : (
                <Button
                  variant="contained"
                  className="btn-tertiary"
                  startIcon={<img alt={`Accept`} src={CheckIcon} />}
                  onClick={() => onAcceptTerms()}
                >
                  Accept Terms and Conditions
                </Button>
              )}
            </div>
            {isShowFooterLoader && <Loader footerLoader={true} />}
          </div>
        )}
      </Formik>
      {showScroller && !isShowFooterLoader && !isloading && (
        <div
          className="scroll-arrow"
          onClick={() => {
            window.scrollTo({
              top: document.documentElement.scrollHeight,
              behavior: "smooth",
            });
          }}
        >
          <img src={DownwardArrow} alt="Scroll Down" />
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  isNavigateToNext: state.navigationFromMenu.isNavigateToNext,
});
export default connect(mapStateToProps)(TermsOfService);
